/* eslint-disable no-console */
<template>
    <div>
        <div class="header_unit header_bg_white">
            <div class="header_box">
                <div class="menu_left">
                    <router-link class="icn_back_black" :to="{ name: 'top' , params: {brandPath: this.$route.params.brandPath} } ">
                        <p class="top_tit">＜戻る</p></router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_l top_tit">設定メニュー</p>
                </div>
            </div>
        </div>
        <ManagerMenuList/>
    </div>
</template>

<script>

    import ManagerMenuList from "../components/ManagerMenuList";
    export default {
        name: 'managemenu',
        components: {
            ManagerMenuList
        }
    }
</script>
